import React, { useState } from 'react';
import { Translation } from 'react-i18next';
import { Modal, Typography, Empty, Row, Col } from 'antd';

import Logger from '../../../../../lib/Logger';
import LearningAdminModuleSerieModalModuleSeries from '../containers/LearningAdminModuleModalModuleSeriesContainer';
import useDebounce from '../../../elements/components/useDebounce';
import LearningAdminModuleSerieModalModulesFilters from './LearningAdminModuleSerieModalModulesFilters';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const { Title, Text } = Typography;

const LearningAdminModuleSerieModalPreview = ({
  hideDetail,
  isVisible,
  moduleSerieTypes,
  defaultOrderModuleSeries,
  defaultLimitModuleSeries,
  totalRecommended,
  totalMoreContent,
  total,
  trackerActions,
  ...props
}) => {
  const [query, setQuery] = useState('');
  const debouncedQuery = useDebounce(query, 1000);
  const [selectedTags, setSelectedTags] = useState([]);

  const onSearch = (e) => {
    setQuery(e.target.value);
  };

  const onClickCancel = () => {
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_CLOSE_PREVIEW
    );
    setQuery('');
    setSelectedTags([]);
    hideDetail();
  };

  return (
    <Translation>
      {(t) => (
        <>
          <Modal
            zIndex={3}
            title={
              <Title
                level={3}
                className='learning-admin-module-serie-preview-title'
              >
                {t('learning_admin_module_serie_preview_title')}
              </Title>
            }
            centered
            className='learning-admin-module-serie-preview'
            visible={isVisible}
            onCancel={onClickCancel}
            footer={null}
            width={1500}
            bodyStyle={{ paddingTop: 0 }}
            destroyOnClose
          >
            <div className='learning-admin-module-serie-preview-content'>
              <Row gutter={16}>
                <Col
                  lg={{ span: 18, order: 1 }}
                  md={{ span: 24, order: 2 }}
                  sm={{ span: 24, order: 2 }}
                  xs={{ span: 24, order: 2 }}
                >
                  {moduleSerieTypes.map((x) => (
                    <LearningAdminModuleSerieModalModuleSeries
                      trackerActions={trackerActions}
                      key={x.value}
                      action={x.action}
                      value={x.value}
                      totalRecommended={totalRecommended}
                      totalMoreContent={totalMoreContent}
                      total={total}
                      defaultOrderModuleSeries={defaultOrderModuleSeries}
                      defaultLimitModuleSeries={defaultLimitModuleSeries}
                      debouncedQuery={debouncedQuery}
                      selectedTags={selectedTags}
                      isVisible={isVisible}
                    />
                  ))}
                  {total === 0 && (
                    <div className='learning-empty'>
                      <Empty
                        description={
                          <>
                            <Title level={3} className='learning-empty-title'>
                              {t('learning_empty_title')}
                            </Title>
                            <Text>{t('learning_empty_description')}</Text>
                          </>
                        }
                      />
                    </div>
                  )}
                </Col>

                <Col
                  lg={{ span: 6, order: 2 }}
                  md={{ span: 24, order: 1 }}
                  sm={{ span: 24, order: 1 }}
                  xs={{ span: 24, order: 1 }}
                >
                  <LearningAdminModuleSerieModalModulesFilters
                    onSearch={onSearch}
                    selectedTags={selectedTags}
                    setSelectedTags={setSelectedTags}
                  />
                </Col>
              </Row>
            </div>
          </Modal>
        </>
      )}
    </Translation>
  );
};

export default LearningAdminModuleSerieModalPreview;

Logger.log('silly', `LearningAdminModuleSerieModalPreview loaded.`);
